// Access to modals attributes
export const DATA_MODAL_TYPE = 'data-modal-type';
export const DATA_MODAL_TITLE = 'data-modal-title';
export const DATA_MODAL_SIZE = 'data-modal-size';
export const DATA_MODAL_BACKDROP = 'data-modal-backdrop';
export const DATA_MODAL_CLOSEBUTTON = 'data-modal-closebutton';
export const DATA_MODAL_ONESCAPE = 'data-modal-onescape';
export const DATA_MODAL_CURRENT_STEP = 'data-modal-current-step';
export const STEP_MODAL = 'steps';
export const DEFAULT_MODAL = 'default';
export const ALERT_MODAL = 'alert';
export const TRANSACTIONAL_MODAL = 'transactional';
export const FULL_MODAL = 'full';
